import React, { useState, useRef, useEffect } from "react";
import {
  FaTimes,
  FaHome,
  FaBars,
  FaThList,
  FaSearch,
  FaGraduationCap,
  FaUniversity,
  FaImage,
  FaFileContract,
  FaShieldAlt,
  FaHandshake,
  FaBlog,
  FaTachometerAlt,
  FaUserCircle,
  FaShoppingCart 
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logoSrc from "../image/latin_logo.png"
import { useSelector } from "react-redux";

// MobileSidebar (fixed)
// - Home click will navigate to '/' and WILL NOT open the popup drawer
// - Menu / Categories / Search open the popup drawer as before
// - Fixed potential source of React error #130 by ensuring menu item 'to' is a string
//   and by not attempting to render anything that could be undefined/null as a component.

export default function MobileSidebar() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showDrop, setShowDrop] = useState(false);
  const [searchText, setSearchText] = useState("");

  // derive tab name from pathname for consistent highlighting
  useEffect(() => {
    const path = location.pathname || "/";
    if (path === "/") setActiveTab("home");
    else if (path.startsWith("/gallery")) setActiveTab("gallery");
    else setActiveTab("");
  }, [location.pathname]);

  const canvasRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const wrapper = wrapperRef.current;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = window.innerWidth);
    let h = (canvas.height = wrapper.clientHeight + 120);
    const particles = [];
    const PARTICLE_COUNT = 120;

    const rand = (min, max) => Math.random() * (max - min) + min;

    function init() {
      particles.length = 0;
      for (let i = 0; i < PARTICLE_COUNT; i++) {
        particles.push({
          x: Math.random() * w,
          y: Math.random() * h,
          vx: rand(-0.15, 0.15),
          vy: rand(-0.3, 0.2),
          r: rand(0.6, 2.8),
          alpha: rand(0.05, 0.8),
          life: rand(80, 360),
          ttl: 0,
          // hue tuned to #ad1457 (approx 333°). small random jitter for variety
          colorHue: rand(332, 338),
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (let p of particles) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy -= 0.002 * Math.random();
        p.ttl++;
        if (p.ttl > p.life || p.x < -20 || p.x > w + 20 || p.y < -60 || p.y > h + 30) {
          p.x = rand(w * 0.05, w * 0.95);
          p.y = h - rand(10, 60);
          p.vx = rand(-0.2, 0.2);
          p.vy = rand(-0.8, -0.15);
          p.ttl = 0;
          p.life = rand(160, 420);
          p.alpha = rand(0.05, 0.9);
        }

        // outer glow (radial gradient) — tuned to pink (#ad1457)
        ctx.beginPath();
        const gradient = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 6);
        // hue = p.colorHue (~333), saturation & lightness tuned for pink glow
        gradient.addColorStop(0, `hsla(${p.colorHue}, 80%, 50%, ${p.alpha})`);
        gradient.addColorStop(0.4, `hsla(${p.colorHue}, 70%, 45%, ${p.alpha * 0.35})`);
        gradient.addColorStop(1, `hsla(${p.colorHue}, 60%, 35%, 0)`);
        ctx.fillStyle = gradient;
        ctx.arc(p.x, p.y, p.r * 6, 0, Math.PI * 2);
        ctx.fill();

        // core dot — use exact RGB of #ad1457 (173,20,87) so center is solid pink
        ctx.beginPath();
        ctx.fillStyle = `rgba(173,20,87, ${Math.min(1, p.alpha * 1.2)})`;
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      requestAnimationFrame(draw);
    }

    function resize() {
      w = canvas.width = window.innerWidth;
      h = canvas.height = wrapper.clientHeight + 120;
      init();
    }

    window.addEventListener("resize", resize);
    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

   const all_categories_List = useSelector((state) =>
      state?.allapi?.all_categories_List ? state?.allapi?.all_categories_List : []
    );
    console.log(all_categories_List);
    const categoriesData = all_categories_List
      const categoriesDatas = [
    {
      name: "Finger Rings",
      sub: [
        {
          name: "Diamond Rings",
          sub: [
            { name: "Yellow Diamond Rings", link: "/" },
            { name: "Princess Cut", link: "/" }
          ]
        }
      ],
    },
  ];

  // NOTE: use 'to' (lowercase) so it's unambiguous and always a string
  const menuItems = [
    { name: "Home", icon: <FaHome />, to: "/" },
    { name: "Gallery", icon: <FaImage />, to: "/gallery" },
    { name: "Courses", icon: <FaGraduationCap />, to: "/courses" },
    { name: "Accounts", icon: <FaUniversity />, to: "/accounts" },
    { name: "Dashboard", icon: <FaTachometerAlt />, to: "/seller" },
    { name: "Blogs", icon: <FaBlog />, to: "/blogs-news" },
    { name: "Become a Distributor", icon: <FaHandshake />, to: "/distributor-product" },
    { name: "Privacy Policy", icon: <FaShieldAlt />, to: "/privacy-policy" },
    { name: "Terms & Conditions", icon: <FaFileContract />, to: "/terms-and-condition" },
  ];

  const handleClose = () => setIsOpen(false);

  // helper to get readable popup title
  const popupTitle = (() => {
    if (!activeTab) return "";
    if (activeTab === "menu") return "Menu";
    if (activeTab === "categories") return "Categories";
    if (activeTab === "products") return "Search";
    return activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
  })();

  return (
    <div className="mobilesidebar-new">
      {/* 🟡 FIXED BOTTOM NAV */}
      <div className="mobile-sidebar-nav d-lg-none py-3">
        <Link
          to="/"
          className={`sidebar-item ${activeTab === "home" ? "active sparkle" : ""}`}
          onClick={() => {
            setIsOpen(false);
            setActiveTab("home"); // ✅ bring back active state
          }}
        >

          <FaHome className="color-new-mm" />
          <span className="color-new-mm">Home</span>
          <span className="coin" />
          <span className="coin" />
          <span className="coin" />
        </Link>

        {/* Menu */}
        <div
          role="button"
          tabIndex={0}
          className={`sidebar-item ${activeTab === "menu" ? "active sparkle" : ""}`}
          onClick={() => {
            setIsOpen(true);
            setActiveTab("menu");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setIsOpen(true);
              setActiveTab("menu");
            }
          }}
        >
          <FaBars className="color-new-mm" />
          <span className="color-new-mm">Menu</span>
          <span className="coin" />
          <span className="coin" />
          <span className="coin" />
        </div>

        {/* Categories */}
        <div
          role="button"
          tabIndex={0}
          className={`sidebar-item ${activeTab === "categories" ? "active sparkle" : ""}`}
          onClick={() => {
            setIsOpen(true);
            setActiveTab("categories");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setIsOpen(true);
              setActiveTab("categories");
            }
          }}
        >
          <FaThList className="color-new-mm"  />
          <span className="color-new-mm" >Categories</span>
          <span className="coin" />
          <span className="coin" />
          <span className="coin" />
        </div>

        {/* Search */}
        <div
          role="button"
          tabIndex={0}
          className={`sidebar-item ${activeTab === "products" ? "active sparkle" : ""}`}
          onClick={() => {
            setIsOpen(true);
            setActiveTab("products");
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setIsOpen(true);
              setActiveTab("products");
            }
          }}
        >
          <FaSearch className="color-new-mm"  />
          <span className="color-new-mm"> Search</span>
          <span className="coin" />
          <span className="coin" />
          <span className="coin" />

        </div>
          <Link
          to="/cart"
          className={`sidebar-item ${activeTab === "cart" ? "active sparkle" : ""}`}
          onClick={() => {
            setIsOpen(false);
            setActiveTab("cart"); // ✅ bring back active state
          }}
        >
          <FaShoppingCart className="color-new-mm"  />
          <span className="color-new-mm" >Cart</span>
          <span className="coin" />
          <span className="coin" />
          <span className="coin" />

        </Link>
      </div>

      {/* 🟢 3D Popup Drawer */}
      <div
        className={`custom-popup-overlay ${isOpen ? "show" : ""}`}
        onClick={handleClose}
      >
        <div
          className={`custom-popup ${isOpen ? "popup-open" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="popup-header bg-warning color-new-mm d-flex justify-content-between align-items-center px-3 py-2">
            <h5 className="mb-0 text-uppercase color-new-mm">{popupTitle}</h5>
            <FaTimes className="fs-4" role="button" onClick={handleClose} />
          </div>

          <div className="popup-body p-3 overflow-auto pb-5">
            {activeTab === "menu" && (
              <div className="row text-center g-2">
                {menuItems.map((item, i) => (
                  <div key={i} className="col-6">
                    {/* Defensive: ensure 'to' exists and is a string before rendering Link */}
                    {item && typeof item.to === "string" ? (
                      <Link to={item.to} className="text-decoration-none text-dark" onClick={() => setIsOpen(false)}>
                        <div className="p-3 border rounded-3 shadow-sm h-100 d-flex flex-column justify-content-center">
                          <div className="fs-4 mb-1 color-new-mm">{item.icon}</div>
                          <span className="color-new-mm" >{item.name}</span>
                        </div>
                      </Link>
                    ) : (
                      <div className="p-3 border rounded-3 shadow-sm h-100 d-flex flex-column justify-content-center">
                        <div className="fs-4 mb-1">{item.icon}</div>
                        <span>{item.name}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {activeTab === "categories" && (
  <div className="accordion pb-5" id="catAccordion">
    {categoriesData.map((cat, i) => (
      <div className="accordion-item" key={i}>
        <h2 className="accordion-header">
          <button
            className="accordion-button collapsed color-new-mm"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${i}`}
          >
            {cat.name}
          </button>
        </h2>

        <div
          id={`collapse${i}`}
          className="accordion-collapse collapse"
          data-bs-parent="#catAccordion"
        >
          <div className="accordion-body">
            {cat.subcates?.map((sub, j) => (
              <div key={j} className="mega-sub-block-mobile">
                <strong className="mega-sub-title-mobile">{sub.name}</strong>

                {sub.subjectss?.length > 0 && (
                  <ul className="mega-list-mobile list-unstyled ms-3 mt-2">
                    {sub.subjectss.map((item, k) => {
                      const slug = item?.cate_sulg;
                      const to = `/category-product/${slug}`;
                      const isActive =
                        location.pathname === to ||
                        location.pathname.includes(slug);

                      return (
                        <li key={k}>
                          <Link
                            to={to}
                            className={`mega-link-mobile ${
                              isActive ? "active" : ""
                            }`}
                            onClick={() => setShowDrop(false)}
                          >
                            {item?.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
)}



            {activeTab === "products" && (
              <div className="text-center">
                <input
                  type="text"
                  className="form-control mb-3 color-new-mm"
                  placeholder="Search products..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                {searchText && (
                  <p>
                    Showing results for: <strong>{searchText}</strong>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <footer
        className="footer-3d d-none d-lg-flex color-new-mm"
        style={{
          position: "relative",
          overflow: "hidden",
          padding: "56px 16px 24px",
          
          background: "linear-gradient(135deg, #ffe6f2 0%, #ffd6dd 50%, #ffccd5 100%)",
          borderTop: "4px solid rgba(255,207,64,0.12)",
        }}
        ref={wrapperRef}
      >

        <div className="orb orb1" style={{
          position: 'absolute', borderRadius: '50%', filter: 'blur(36px)', opacity: .22,
          width: 280, height: 280, background: 'radial-gradient(circle,#0bf38a, transparent 40%)',
          top: -80, left: -120, zIndex: 2, animation: 'orbFloat 9s ease-in-out infinite'
        }} />
        <div className="orb orb2" style={{
          position: 'absolute', borderRadius: '50%', filter: 'blur(36px)', opacity: .22,
          width: 320, height: 320, background: 'radial-gradient(circle,#ffd56a, transparent 30%)',
          bottom: -110, right: -100, zIndex: 2, animation: 'orbFloat 11s ease-in-out infinite reverse'
        }} />
        <div className="orb orb3" style={{
          position: 'absolute', borderRadius: '50%', filter: 'blur(36px)', opacity: .22,
          width: 180, height: 180, background: 'radial-gradient(circle,#00a86b, transparent 40%)',
          top: '10%', right: '15%', zIndex: 2, animation: 'orbFloat 7s ease-in-out infinite'
        }} />

        <canvas id="footer-particles" ref={canvasRef}
          style={{ position: 'absolute', inset: 0, zIndex: 3, pointerEvents: 'none' }} />

        <div className="container footer-inner" style={{ maxWidth: 1200, position: 'relative', zIndex: 6 }}>
          <div className="row gy-4 align-items-start">
            <div className="col-md-4">
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div className="logo-3d" style={{
                  display: 'inline-block', width: 110, height: 110, transformStyle: 'preserve-3d',
                  perspective: 800, transition: 'transform .9s cubic-bezier(.2,.9,.25,1)'
                }}>
                  <div className="plate" style={{
                    position: 'relative', width: '100%', height: '100%', borderRadius: '50%',
                    background: 'linear-gradient(145deg, rgba(255,255,255,0.02), rgba(0,0,0,0.15))',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', transform: 'translateZ(30px)'
                  }}>
                    <div className="ring" style={{
                      position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid rgba(255,207,64,0.04)',
                      boxShadow: '0 6px 18px rgba(255,207,64,0.06) inset', transform: 'translateZ(12px) rotateZ(12deg)'
                    }} />
                    <img src={logoSrc} alt="logo" style={{ width: 66, height: 66, borderRadius: '50%', transform: 'translateZ(36px) rotateZ(-6deg)' }} />
                  </div>
                </div>

                <div>
                  <div className="color-new-mm" style={{ color: '#ffcf40', fontWeight: 700, fontSize: 18 }}>latinsyrgold.com</div>
                  <div className="color-new-mm" style={{ color: '#bfeadf', fontSize: 14, marginTop: 4 }}>Distributor • Premium • Dubai</div>
                </div>
              </div>

              <p className=" color-new-mm" >
                High-quality distributors and customer trust since 2025. Reach out for partnerships and wholesale enquiries.
              </p>
            </div>

            <div className="col-md-2">
              <h6 className=" color-new-mm" style={{ color: '#ffcf40', fontSize: "18px" }}>Useful Links</h6>
              <div className="footer-links">
                <Link className="footer-link color-new-mm" to="/blogs-news" style={{ display: 'block', color: '#e7f7ef', margin: '8px 0' }}>Blogs</Link>
                <Link className="footer-link color-new-mm" to="/gallery" style={{ display: 'block', color: '#e7f7ef', margin: '8px 0' }}>Gallery</Link>
                <Link className="footer-link color-new-mm" to="/distributor-product" style={{ display: 'block', color: '#e7f7ef', margin: '8px 0' }}>Become a Distributor</Link>
              </div>
            </div>

            <div className="col-md-3">
              <h6 className=" color-new-mm" style={{ color: '#ffcf40', fontSize: "18px" }}>Consumer Policy</h6>
              <div style={{ marginTop: 8 }}>
                <Link className="footer-link color-new-mm" to="/privacy-policy" style={{ display: 'block', color: '#e7f7ef', margin: '8px 0' }}>Privacy Policy</Link>
                <Link className="footer-link color-new-mm" to="/terms-and-condition" style={{ display: 'block', color: '#e7f7ef', margin: '8px 0' }}>Terms & Conditions</Link>
              </div>
            </div>

            <div className="col-md-3">
              <h6 className=" color-new-mm" style={{ color: '#ffcf40', fontSize: "18px" }}>Contact us</h6>
              <ul style={{ listStyle: 'none', padding: 0, color: '#cfe9dc' }}>
                <li className=" color-new-mm">📞 +971563705658</li>
                <li className=" color-new-mm">✉ info@latinsyrgold.com</li>
                <li className=" color-new-mm">📍 Dubai</li>
              </ul>
            </div>
          </div>

          <div style={{
            marginTop: 28,
            background: 'linear-gradient(90deg, rgba(255,207,64,0.08), rgba(0,0,0,0.02))',
            borderRadius: 12, padding: '12px 16px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            border: '1px solid rgba(255,207,64,0.07)'
          }}>
            <div className=" color-new-mm" style={{ color: '#dfeee0' }}>© 2025 <strong style={{ color: '#ffcf40' }}>Toshin Jewellery</strong> All Rights Reserved.</div>
            <div className=" color-new-mm" style={{ color: '#9fbfb1' }}>Made with care • Dubai</div>
          </div>
        </div>

        {/* small style tags for keyframes inside component */}
        <style>{`
              @keyframes orbFloat{ 0%{ transform: translate3d(0,0,0) scale(1); } 50%{ transform: translate3d(18px,-26px,0) scale(1.05);} 100%{ transform: translate3d(0,0,0) scale(1);} }
            `}</style>
      </footer>
    </div>
  );
}
